import $ from 'jquery'
import _ from 'lodash'
import Backbone from 'backbone'
import isRtl from 'scoreboard/components/is-rtl'

var HeaderControlsPositioner = Backbone.View.extend({

	initialize: function(options = {}) {
		this.options = options
		this.posEl = options.positionedElement
		this.scrollEl = options.scrollElement
		this.scrollContainer = options.scrollContainer
	},

	// Position a given element [posEl] within the header of another given
	// element [scrollEl]. This is used to ensure controls in the metrics and
	// update metrics tables remain visible while the tables are scrolled horizontally.
	setHeaderControlsPosition: function() {
		// Used here in calculations to provide extra padding while positioning
		// this.posEl within the header
		var HEADER_PADDING = 50

		if(this.posEl.length == 0) {
			return
		}

		// e.g. on the red metrics report if there are no metrics
		if (_.isEmpty(this.scrollContainer)) {
			return
		}

		// The scrolling element is positioned absolutely so we'll need to make sure
		// it doesn't overlap anything else it's beside in the dom.
		var header = this.posEl.closest('.panel-header')
		var width = 0
		var minRight = 5
		var maxRight = minRight
		_.each(header.children(), function(el) {
			width += $(el).outerWidth()
		})

		header.css({ 'min-width': width + HEADER_PADDING})
		maxRight = header.width() - width

		var scrollingCellWidth = this.scrollContainer.width()
		var scrollPosition = this.scrollContainer[0].scrollLeft
		var right = this.scrollEl.width() - scrollingCellWidth + HEADER_PADDING
		right += (isRtl() ? 1 : -1) * scrollPosition
		if(right < minRight) {
			// If we'd have to move the positioned element outside the scrolled element, don't
			right = minRight
		}

		this.posEl.css({
			'position': 'absolute',
			'top': this.options.top || 0,
			'inset-inline-end': maxRight < right ? maxRight : right
		})
	}
})

export default HeaderControlsPositioner

HeaderControlsPositioner.__filename__ = 'components/header-controls-positioner.js'
